var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{staticClass:"pa-5",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v(" "+_vm._s(_vm.stock.toUpperCase())+" Volume - "),_c('span',{attrs:{"id":"volume"}}),_vm._v(" Daily Variation Breakdown vs. Median 90d ")]),_c('VolumeBreakdownChart',{attrs:{"id":_vm.stock,"apiEndpoint":'/get-stock-volume-breakdown/',"date-key":"date","bar-keys":[
            'MedianVolume',              
            'Country',
            'Market',
            'Mom',
            'Quality',
            'Residuals',
            'Risk',
            'Sector',
            'Size',
            'Value',
            'ReducedDemand' ],"barColors":[
            '#00868a',
            '#0c2243',
            '#e9507f',  
            '#865986',
            '#bbc7da',
            '#3a99ec',
            '#38edd5',
            '#f8cbd9',
            '#f47a7a',
            '#ffff7f',
            '#FC6E51',
            '#A0CECB' ],"line-key":"Volume"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }